import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { BlankSlate, Button } from '@factorialco/deprecated-design-system'
import { MyCardFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import RequestSingleUseCardBlock from 'modules/expenses/components/cards/CardsPageBlocks/RequestSingleUseCardBlock'

import CardsGrid from '../MyCardsList/CardsGrid'

interface ContentProps {
  cards: MyCardFragment[]
  canCreateSingleUseCard: boolean
}

const Content = ({ cards, canCreateSingleUseCard }: ContentProps) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const onRequestSingleUseCard = () => {
    navigate(navigation.myCards.requestCard.fullPath())
    track(trackingEvents.expenses.gotToCreateCard)
  }

  const RequestSingleUseCardButton = () => {
    return (
      <Button
        type="primary"
        disabled={!canCreateSingleUseCard}
        onClick={() => {
          onRequestSingleUseCard()
        }}
        iconName="add"
      >
        {i18n.t('expenses_v2.buttons.request_single_use_card')}
      </Button>
    )
  }

  if (!cards.length) {
    if (!canCreateSingleUseCard) {
      return (
        <BlankSlate
          illustration="credit-card"
          title={i18n.t('expenses_v2.cards.empty_states.no_cards.title')}
          description={i18n.t('expenses_v2.cards.empty_states.no_cards.description')}
        />
      )
    }

    return <RequestSingleUseCardBlock button={React.createElement(RequestSingleUseCardButton)} />
  }

  const cardsStatusOrder = ['active', 'pending', 'requested', 'inactive', 'canceled', 'rejected']
  const cardsForSorting = [...cards]

  const sortedCards = cardsForSorting.sort((cardA, cardB) => {
    const indexA = cardsStatusOrder.indexOf(cardA.status)
    const indexB = cardsStatusOrder.indexOf(cardB.status)

    if (indexA > indexB) {
      return 1
    }
    if (indexA < indexB) {
      return -1
    }
    if (cardA.createdAt < cardB.createdAt) {
      return -1
    }
    if (cardA.createdAt > cardB.createdAt) {
      return 1
    }
    return 0
  })

  return <CardsGrid cards={sortedCards} />
}

export default observer(Content)
